import { flattenConnection } from '@shopify/hydrogen-react'
import { motion } from 'motion/react'

import { MiniProductCard } from 'components/Product/MiniProductCard'

export const RecommendationsTab = ({ products }) => {
  return (
    <motion.div
      className="scrollbar-hidden flex h-full flex-col gap-8 overflow-y-scroll"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{
        duration: 0.2,
        ease: 'easeInOut',
      }}
    >
      {products.map((product, i) => {
        if (i > 3) return null
        const image = flattenConnection(product.images)[0] as any
        const src = image?.src ?? ''
        return (
          <MiniProductCard
            size="small"
            key={product._id}
            product={product}
            aspect={`${image.width}/${image.height}`}
            src={src}
          />
        )
      })}
    </motion.div>
  )
}
